import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://nixuroxuajgcyufrngpm.supabase.co"
const supabaseAnonKey = "sb_publishable_vT8lQ2EOcjxXiOWXg9XECA_6SgykTDn"

export const supabase = createClient(supabaseUrl, supabaseAnonKey)